import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';

const ViewWalletLogs = ({ logs }) => {
  const table_data = (
    !logs.length ? (
      <tr>
        <td colSpan="12" className="p-4">No Available Logs. </td>
      </tr>
    ) : (
      logs.map(data => {
        return (
          <tr key={_.get(data, 'id')}>
            <td className="p-2">{_.get(data, 'id') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.description') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.amount') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.txnid') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.refno') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.pgi_url') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.pending_at') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.status') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.remarks') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.payment_channel') || 'N/A'}</td>
            <td className="p-2">{_.get(data, 'attributes.payment_channel_branch') || 'N/A'}</td>
          </tr>
        )
      })
    )
  )
  return (
    <Modal.Body>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginBottom: "20px",
          overflow: "auto",
        }}
      >
        <div className="mb-3" />
        <div className="table-responsive" style={{width: '200%'}}>
          <table className="table table-striped table-sm table-bordered table-hover">
            <thead className="table-header">
              <tr>
                <th className="p-2" scope="col">#</th>
                <th className="p-2" scope="col"> DESCRIPTION</th>
                <th className="p-2" scope="col">AMOUNT</th>
                <th className="p-2" scope="col">TXNID</th>
                <th className="p-2" scope="col">REFERENCE NUMBER</th>
                <th className="p-2" scope="col">PGI GENERATED AT</th>
                <th className="p-2" scope="col">PENDING AT</th>
                <th className="p-2" scope="col">STATUS</th>
                <th className="p-2" scope="col">REMARKS</th>
                <th className="p-2" scope="col">PAYMENT CHANNEL</th>
                <th className="p-2" scope="col">PAYMENT CHANNEL BRANCH</th>
              </tr>
            </thead>
            <tbody className="table-details">
              {table_data}
            </tbody>
          </table>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewWalletLogs.propTypes = {
  logs: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewWalletLogs);
